import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdOpsCodeContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type { AysCodeResponse } from '@bindoc-projects/code-domain-lib';
import { AysCode } from '@bindoc-projects/code-domain-lib';

export const FilterConditionOpsCodeFourDigitsPluginType: FilterConditionPluginSpecification<
  AysCode[],
  FilterConditionOpsCodeFourDigitsDto,
  BdOpsCodeContentCondition
> = {
  type: 'fourDigitOpsCode',
  category: 'case',
  displayName: { de: 'OPS-Ziffer 4-Steller' },
  sortingIndex: 11,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionOpsCodeFourDigitsDto,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeFourDigitsPlugin(
        obj.codes.map((it) => AysCode.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdOpsCodeContentCondition,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeFourDigitsPlugin(
        (jsonObj.includes ?? []).map((it) => AysCode.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeFourDigitsPlugin([]);
  },
};

export class FilterConditionOpsCodeFourDigitsPlugin extends FilterConditionPluginImpl<
  AysCode[],
  FilterConditionOpsCodeFourDigitsDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCode[],
    FilterConditionOpsCodeFourDigitsDto,
    BdOpsCodeContentCondition
  > = FilterConditionOpsCodeFourDigitsPluginType;

  constructor(private codes: AysCode[]) {
    super(FilterConditionOpsCodeFourDigitsPluginType.type);
  }

  clone(): FilterConditionOpsCodeFourDigitsPlugin {
    return new FilterConditionOpsCodeFourDigitsPlugin([
      ...this.codes.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionOpsCodeFourDigitsPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.codes,
        other.codes,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.codes.length === 0) {
      return 'Mindestens eine OPS-Ziffer auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdOpsCodeContentCondition(this.codes, []);
  }

  toJSON(): FilterConditionOpsCodeFourDigitsDto | null {
    return {
      type: this.type,
      codes: this.codes,
    };
  }

  toText(): string | null {
    return 'OPS-Ziffer 4-Steller';
  }

  toValue(): AysCode[] {
    return this.codes;
  }
}

interface FilterConditionOpsCodeFourDigitsDto {
  type: string;
  codes: AysCodeResponse[];
}
